import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const publicPaths = [
    '/',
    '/calculator',
    '/contact',
    '/services',
    '/about',
    '/faq',
    '/terms'
];

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const isPublicPath = publicPaths.includes(location.pathname);
    const token = localStorage.getItem('authToken');

    if (!token && !isPublicPath) {
        // Store the attempted path
        sessionStorage.setItem('redirectPath', location.pathname);
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default PrivateRoute; 